(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(46508);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RenderEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22067);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87148);
/* harmony import */ var services_AuthServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(960);
/* harmony import */ var services_BackendSDKService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40424);
/* harmony import */ var services_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18351);








function RenderEnum(props) {
    var getCustomEnum = function getCustomEnum(data) {
        var enumData = data === null || data === void 0 ? void 0 : data.find(function(item) {
            return item._id === props.code;
        });
        return enumData === null || enumData === void 0 ? void 0 : enumData.Options.find(function(item) {
            return item.Value === props.value;
        });
    };
    var customEnum = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)("custom-enum-auto-complete", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var customEnumQuery;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        services_BackendSDKService__WEBPACK_IMPORTED_MODULE_3__/* .bSdk.cmsQuery */ .P.cmsQuery("custom-enum", undefined, {
                            route: "/",
                            method: "get",
                            authToken: services_AuthServices__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken(),
                            query: {
                                page: 0,
                                pageSize: 0
                            }
                        })
                    ];
                case 1:
                    customEnumQuery = _state.sent();
                    return [
                        2,
                        customEnumQuery.data
                    ];
            }
        });
    }));
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var enumObj = getCustomEnum(customEnum.data);
    if (!enumObj) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            width: "1px"
        },
        children: props.renderValueIfLabelNotFound && props.value
    });
    var label = enumObj === null || enumObj === void 0 ? void 0 : enumObj.Label;
    if (!label && props.renderValueIfLabelNotFound) label = props.value;
    if (props.render) {
        return props.render(enumObj);
    }
    if (props.chip) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                badgeContent: props.count ? props.count : 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        color: services_Utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getContrastText */ .Z.getContrastText(theme, enumObj === null || enumObj === void 0 ? void 0 : enumObj.BackgroundColor),
                        fontWeight: "bold",
                        backgroundColor: props.noColor ? "" : enumObj === null || enumObj === void 0 ? void 0 : enumObj.BackgroundColor,
                        padding: "5px 8px",
                        borderRadius: 20,
                        fontSize: 13
                    },
                    children: label
                })
            })
        });
    }
    if (props.renderAsString) return label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            color: props.noColor ? "" : enumObj === null || enumObj === void 0 ? void 0 : enumObj.BackgroundColor
        },
        children: label
    });
}


/***/ }),

/***/ 54958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31834);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54799);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51190);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67720);
/* harmony import */ var common_misc_RIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84144);






/**
 * @category Frontend
 * @subcategory Modal
 * @description
 * - When title is not provided to modal, it will not show title.
 * - This component is used to show title of the modal.
 * - By default it will show back button on the left side.
 * - If you want to show close button on the right side, you can pass `closeButton` as `CROSS`.
 * - It will show save button on the right side by default.
 * - If you want to hide save button, you can pass `noSaveButton` as `true`.
 * You can also pass custom save button to the right side by passing `customSaveButton` as ReactNode.
 *
 * @param props - The props for the ModalTitle component
 * @param props.title - The title of the modal (string or ReactNode)
 * @param props.onBack - Function to call when the back button is clicked
 * @param props.onSave - Function to call when the save button is clicked
 * @param props.loading - Whether the save button should show a loading state
 * @param props.customSaveButton - Custom save button to display instead of the default
 * @param props.closeButton - Type of close button to display ('BACK' or 'CROSS')
 * @param props.noSaveButton - Whether to hide the save button
 * @param props.sticky - Whether the title should stick to the top of the modal
 * @param props.saveButtonProps - Additional props to pass to the save button
 */ function ModalTitle(props) {
    var closeButton = props.closeButton || "BACK";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "draggable-handle",
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "2px 0px"
                }, props.sticky ? {
                    background: "white",
                    position: "sticky",
                    top: 0,
                    zIndex: 5
                } : {}),
                children: [
                    closeButton === "BACK" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        onClick: props.onBack,
                        sx: {
                            pointerEvents: "auto"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: "arrow_back"
                        })
                    }),
                    typeof props.title === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: props.title
                    }) : props.title,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    props.customSaveButton,
                    !props.noSaveButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                        // disabled={objForm ? !objForm?.formState.isDirty: undefined}
                        loading: props.loading,
                        type: "submit",
                        onClick: props.onSave
                    }, props.saveButtonProps), {
                        children: "Save"
                    })),
                    closeButton === "CROSS" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        onClick: props.onBack,
                        sx: {
                            pointerEvents: "auto",
                            marginLeft: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(common_misc_RIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            name: "close",
                            color: "primary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: {
                    marginBottom: 2
                }
            })
        ]
    });
}


/***/ }),

/***/ 49161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ValidationErrorList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1691);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63955);




function getFlatErrorList(errors) {
    var lstErrors = [];
    var aryErrors = getErrorMessage(errors);
    if (Array.isArray(aryErrors)) lstErrors = lstErrors.concat(aryErrors);
    if (typeof aryErrors === "string") lstErrors.push(aryErrors);
    return lstErrors;
}
function getErrorMessage(objErr) {
    if (!objErr) return [];
    var lstMessages = [];
    if (Array.isArray(objErr)) {
        var aryErrorList = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = objErr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                var lstError = getErrorMessage(obj);
                if (Array.isArray(lstError)) {
                    aryErrorList = aryErrorList.concat(lstError);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        lstMessages = aryErrorList;
    }
    if (typeof objErr === "object" && !(objErr === null || objErr === void 0 ? void 0 : objErr.message)) {
        // It's nested error
        var aryErrorList1 = [];
        var lstError1 = Object.values(objErr);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = lstError1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var obj1 = _step1.value;
                aryErrorList1 = aryErrorList1.concat(getErrorMessage(obj1));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        lstMessages = aryErrorList1;
    }
    if (typeof objErr === "object" && (objErr === null || objErr === void 0 ? void 0 : objErr.message)) {
        lstMessages = [
            objErr === null || objErr === void 0 ? void 0 : objErr.message
        ];
    }
    if (typeof objErr === "string") {
        lstMessages = [
            objErr
        ];
    }
    return lstMessages;
}
function ValidationErrorList() {
    var ref, ref1;
    var objForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)();
    if (!(objForm === null || objForm === void 0 ? void 0 : (ref = objForm.formState) === null || ref === void 0 ? void 0 : ref.errors)) return null;
    // let lstErrors = Object.values(objForm.formState.errors);
    var flatErrorList = getFlatErrorList(objForm === null || objForm === void 0 ? void 0 : (ref1 = objForm.formState) === null || ref1 === void 0 ? void 0 : ref1.errors);
    if (flatErrorList.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            icon: false,
            severity: "error",
            children: flatErrorList.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        item === null || item === void 0 ? void 0 : item.toString(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                }, index);
            })
        })
    });
}


/***/ }),

/***/ 98128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MasterClientGuard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69397);
/* harmony import */ var components_assets_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33240);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51228);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var services_AuthServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(960);
/* harmony import */ var stores_authStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86768);







function MasterClientGuard(props) {
    var ref, ref1, ref2;
    var auth = (0,contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)();
    var selectedMasterClient = stores_authStore__WEBPACK_IMPORTED_MODULE_5__/* .AuthStore.useState */ .Cn.useState().selectedMasterClient;
    var access = ((ref = stores_authStore__WEBPACK_IMPORTED_MODULE_5__/* .AuthStore.getRawState */ .Cn.getRawState().user) === null || ref === void 0 ? void 0 : (ref1 = ref.Access) === null || ref1 === void 0 ? void 0 : ref1.MasterClients) || [];
    if (!auth.isUserDataFetched) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_assets_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}); // Loading
    var defaultFallback = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "h5",
                sx: {
                    p: 2,
                    fontWeight: "bold"
                },
                children: "This page is not for you"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: {
                    fontWeight: "bold"
                },
                onClick: function() {
                    services_AuthServices__WEBPACK_IMPORTED_MODULE_4__/* ["default"].onLogout */ .Z.onLogout();
                },
                children: "Log Out"
            })
        ]
    });
    var fallback = props.fallback !== undefined ? props.fallback : defaultFallback;
    if ((access === null || access === void 0 ? void 0 : access.length) === 0) {
        {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: fallback
            });
        }
    }
    if (((ref2 = auth.user) === null || ref2 === void 0 ? void 0 : ref2._id) && selectedMasterClient) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: props.children
        }, selectedMasterClient === null || selectedMasterClient === void 0 ? void 0 : selectedMasterClient._id);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            variant: "h5",
            sx: {
                p: 2,
                fontWeight: "bold"
            },
            children: "No Master Client is Selected"
        })
    });
}


/***/ }),

/***/ 50822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ withData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64468);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_assets_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33240);
/* harmony import */ var common_ErrorPlaceHolder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39642);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
// import useApiCall from "hooks/useApiCall";
// import { useEffect } from "react";








// export function withData<P extends { data?: any }>(
//   Component: React.ElementType<P>,
//   fetchData: () => Promise<any>
// ) {
//   return (props: JSX.IntrinsicElements & P) => {
//     const apiCall = useApiCall<any>(fetchData);
//     useEffect(() => {
//       apiCall.init();
//     }, []);
//     if (apiCall.loading) return <Loading />;
//     if (apiCall.error) return <ErrorPlaceHolder ex={apiCall.error} />;
//     return <Component {...props} data={apiCall.data} />;
//   };
// }

var withData = function(Component, fetchData, options) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithData, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithData);
        function WithData() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithData);
            var _this;
            _this = _super.apply(this, arguments);
            _this.state = {
                isLoading: true,
                error: undefined,
                data: undefined
            };
            return _this;
        }
        var _proto = WithData.prototype;
        _proto.componentDidMount = function componentDidMount() {
            var _this = this;
            this.setState({
                isLoading: true
            });
            fetchData(this.props).then(function(data) {
                _this.setState({
                    data: data
                });
            }).catch(function(ex) {
                return _this.setState({
                    error: ex
                });
            }).finally(function() {
                _this.setState({
                    isLoading: false
                });
            });
        };
        _proto.render = function render() {
            var ref;
            if (this.state.isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_assets_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
            if (this.state.error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(common_ErrorPlaceHolder__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ex: this.state.error
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, this.props), {
                data: this.state.data || ((ref = this.props) === null || ref === void 0 ? void 0 : ref.data)
            }));
        };
        return WithData;
    }(react__WEBPACK_IMPORTED_MODULE_3__.Component);
};
/* harmony default export */ __webpack_exports__["Z"] = (withData);


/***/ }),

/***/ 46508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ../commonlib/dist/index.js
var dist = __webpack_require__(19129);
// EXTERNAL MODULE: ./guards/MasterClientGuard.tsx
var MasterClientGuard = __webpack_require__(98128);
// EXTERNAL MODULE: ../../node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(58211);
// EXTERNAL MODULE: ./services/AuthServices.ts
var AuthServices = __webpack_require__(960);
// EXTERNAL MODULE: ./stores/authStore.ts
var authStore = __webpack_require__(86768);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/index/report-automation/ReportAutomationDashboard.tsx




function ReportAutomationDashboard(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                children: "Report Automation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignContent: "center",
                    columnGap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/business-entity",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            children: "Business Entity List"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/entity-sales-summary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            children: "Daily Sales"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/entity-hourly-sales",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            children: "Hourly Sales"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/sales-comparison-report",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            children: "Sales Comparison Summary"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/FileDownloadDone.js
var FileDownloadDone = __webpack_require__(96810);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/PendingActions.js
var PendingActions = __webpack_require__(20127);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/People.js
var People = __webpack_require__(94536);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Rule.js
var Rule = __webpack_require__(76899);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Telegram.js
var Telegram = __webpack_require__(32374);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./hooks/commonQuries.ts
var commonQuries = __webpack_require__(64480);
// EXTERNAL MODULE: ./services/Utils.ts
var Utils = __webpack_require__(18351);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(62623);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(28492);
// EXTERNAL MODULE: ./common/LoadingCircularProgress.tsx
var LoadingCircularProgress = __webpack_require__(53533);
;// CONCATENATED MODULE: ./components/index/DashboardCard.tsx




var DashboardCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
                minWidth: 75
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3,
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: props.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCircularProgress/* default */.Z, {}) : props.icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 9,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                fontSize: "35px",
                                color: "initial",
                                children: props.value
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 9,
                            sx: {
                                marginTop: "-12px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "caption",
                                fontSize: "18px",
                                children: props.title
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var index_DashboardCard = (DashboardCard);

;// CONCATENATED MODULE: ./components/index/tax-filing-automation/TaxFilingAutomationDashboard.tsx










function TaxFilingAutomationDashboard(props) {
    var objDashboardCounts = (0,commonQuries/* useList */.sm)("master-client/getDashboard");
    if (!objDashboardCounts.data) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                children: "Tax Filing Dashboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        lg: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/sub-client",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_DashboardCard, {
                                isLoading: objDashboardCounts.isLoading,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(People/* default */.Z, {
                                    sx: {
                                        fontSize: "32px"
                                    }
                                }),
                                title: objDashboardCounts.data[0].TotalSubClients.label,
                                value: Utils/* default.showNumber */.Z.showNumber(objDashboardCounts.data[0].TotalSubClients.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        lg: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/tax-filings",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_DashboardCard, {
                                isLoading: objDashboardCounts.isLoading,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingActions/* default */.Z, {
                                    sx: {
                                        fontSize: "32px"
                                    }
                                }),
                                title: objDashboardCounts.data[0].PendingRevenueSubmission.label,
                                value: Utils/* default.showNumber */.Z.showNumber(objDashboardCounts.data[0].PendingRevenueSubmission.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        lg: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/tax-filings",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_DashboardCard, {
                                isLoading: objDashboardCounts.isLoading,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Telegram/* default */.Z, {
                                    sx: {
                                        fontSize: "32px"
                                    }
                                }),
                                title: objDashboardCounts.data[0].TotalTaxFilled.label,
                                value: Utils/* default.showNumber */.Z.showNumber(objDashboardCounts.data[0].TotalTaxFilled.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        lg: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/tax-filings",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_DashboardCard, {
                                isLoading: objDashboardCounts.isLoading,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rule/* default */.Z, {
                                    sx: {
                                        fontSize: "32px"
                                    }
                                }),
                                title: objDashboardCounts.data[0].FailedFilings.label,
                                value: Utils/* default.showNumber */.Z.showNumber(objDashboardCounts.data[0].FailedFilings.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        lg: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/tax-filings",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_DashboardCard, {
                                isLoading: objDashboardCounts.isLoading,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileDownloadDone/* default */.Z, {
                                    sx: {
                                        fontSize: "32px"
                                    }
                                }),
                                title: objDashboardCounts.data[0].submittedRevenue.label,
                                value: Utils/* default.showNumber */.Z.showNumber(objDashboardCounts.data[0].submittedRevenue.value)
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(22067);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16003);
// EXTERNAL MODULE: ./common/custom/ReactQueryLoadingError.tsx
var ReactQueryLoadingError = __webpack_require__(60728);
// EXTERNAL MODULE: ./components/tourism-tax-filings/TourismTaxStore.tsx
var TourismTaxStore = __webpack_require__(7287);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(87148);
// EXTERNAL MODULE: ./services/BackendSDKService.ts
var BackendSDKService = __webpack_require__(40424);
;// CONCATENATED MODULE: ./components/index/tax-filing-automation/TaxFilingAutomationDashboardForMasterClient.tsx










function TaxFilingAutomationDashboardForMasterClient(props) {
    var ref, ref1, ref2, ref3;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var q = (0,es.useQuery)([
        "tax-filing-summary-for-landing-page",
        props.MasterClientID
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        BackendSDKService/* bSdk.TaxFilings_GetTaxFilingSummary */.P.TaxFilings_GetTaxFilingSummary({
                            MasterClientID: props.MasterClientID || "",
                            Month: dist.CommonDateUtils.getPreviousMonthYYYYMM()
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    }), {
        cacheTime: 0
    });
    var isSalesTaxEnabled = (ref = q.data) === null || ref === void 0 ? void 0 : ref.SalesTaxSummary.find(function(item) {
        return !!item.count;
    });
    var isTourismTaxEnabled = (ref1 = q.data) === null || ref1 === void 0 ? void 0 : ref1.TourismTaxSummary.find(function(item) {
        return !!item.count;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactQueryLoadingError/* default */.Z, {
                    q: q
                })
            }),
            isSalesTaxEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-blue text-large",
                        children: "State Sales & Use Tax accounts"
                    }),
                    (ref2 = q.data) === null || ref2 === void 0 ? void 0 : ref2.SalesTaxSummary.map(function(item) {
                        if (item.count === 0) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            badgeContent: item.count,
                            sx: {
                                m: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: item.label,
                                sx: {
                                    backgroundColor: item.color,
                                    color: theme.palette.getContrastText(item.color || "#FFFFFF"),
                                    fontWeight: "bold"
                                },
                                onClick: function() {
                                    router.push("/tax-filings?status=".concat(item.key));
                                }
                            })
                        }, item.label);
                    })
                ]
            }),
            isTourismTaxEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-blue text-large",
                        children: "County Tourism Tax accounts"
                    }),
                    (ref3 = q.data) === null || ref3 === void 0 ? void 0 : ref3.TourismTaxSummary.map(function(item) {
                        if (item.count === 0) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            badgeContent: item.count,
                            sx: {
                                m: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                label: item.label,
                                sx: {
                                    backgroundColor: item.color,
                                    color: theme.palette.getContrastText(item.color || "#FFFFFF"),
                                    fontWeight: "bold"
                                },
                                onClick: function() {
                                    TourismTaxStore/* TourismTaxStore.update */.h.update(function(s) {
                                        s.SelectedTaxFilingStatus = item;
                                    });
                                    router.push("/tourism-tax-filings");
                                }
                            })
                        }, item.label);
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/index/Dashboard.tsx










function Dashboard() {
    var MasterClientID = (0,authStore/* useMasterClientID */.Cy)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            m: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MasterClientGuard/* default */.Z, {
            fallback: null,
            children: [
                AuthServices/* default.isFeatureEnabled */.Z.isFeatureEnabled(dist.MASTER_CLIENT_FEATURE.REPORT_AUTOMATION) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportAutomationDashboard, {}),
                AuthServices/* default.isFeatureEnabled */.Z.isFeatureEnabled(dist.MASTER_CLIENT_FEATURE.TAX_FILING_AUTOMATION) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm/* Switch */.rs, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                            condition: AuthServices/* default.is */.Z.is("ADMIN"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxFilingAutomationDashboard, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Case */.JZ, {
                            condition: !AuthServices/* default.is */.Z.is("ADMIN"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TaxFilingAutomationDashboardForMasterClient, {
                                MasterClientID: MasterClientID || "NA"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./guards/AuthGuard.tsx + 5 modules
var AuthGuard = __webpack_require__(65430);
// EXTERNAL MODULE: ./layouts/main/MainLayout.tsx + 12 modules
var MainLayout = __webpack_require__(34107);
;// CONCATENATED MODULE: ./pages/index.tsx




var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthGuard/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard, {})
        })
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 38660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DR": function() { return /* binding */ convertDateToYYYYMM; },
/* harmony export */   "b5": function() { return /* binding */ convertToServerDateISO; },
/* harmony export */   "f5": function() { return /* binding */ convertToServerDate; },
/* harmony export */   "mQ": function() { return /* binding */ parseDateWithoutTimeZone; },
/* harmony export */   "sG": function() { return /* binding */ parseDate; },
/* harmony export */   "t_": function() { return /* binding */ parseDateFromYYYYMM; }
/* harmony export */ });
/* unused harmony export convertDateToYYYYMMDD */
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18588);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88299);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22601);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(date_fns_tz__WEBPACK_IMPORTED_MODULE_1__);



function convertToServerDateISO(date) {
    if (!date) return "";
    return (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_1__.zonedTimeToUtc)(date, config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SERVER_TIMEZONE */ .Z.SERVER_TIMEZONE).toISOString();
}
function convertToServerDate(date) {
    if (!date) return "";
    return (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_1__.zonedTimeToUtc)(date, config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SERVER_TIMEZONE */ .Z.SERVER_TIMEZONE);
}
function parseDateFromYYYYMM(strDate) {
    if (typeof strDate !== "string") return strDate;
    return new Date("".concat(strDate.replace(/-/g, "/"), "/02"));
}
function convertDateToYYYYMM(date) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(parseDate(date), "yyyy-MM");
}
function convertDateToYYYYMMDD(date) {
    return format(parseDate(date), "yyyy-MM-dd");
}
function parseDateWithoutTimeZone(strDate) {
    var date = strDate;
    if (typeof strDate === "string") date = strDate.replace("Z", "");
    return new Date(date);
}
function parseDate(date) {
    if (typeof date === "object") return new Date(date);
    if (typeof date === "string") return new Date(date);
    return date;
}


/***/ }),

/***/ 9143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ prettyPercentage; }
/* harmony export */ });
var intlObj = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "USD"
});
var percentageObj = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: "percent"
});
function prettyPercentage(number) {
    var num = parseFloat(number);
    if (Number.isNaN(num)) return "";
    return percentageObj.format(num / 100);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [100,9044,8694,4107,3398,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);